

<span class="_label">{{'OAT.ordered-by' | translate}}:</span>
@for (diner of diners; track diner; let index = $index) {
	<span class="_badge" style="margin-inline-start: 5px" [style.margin-inline-start]="(index * -3) + 'px'" [style.background]="diner.background">
		@if (diner.icon) {
			<mat-icon svgIcon="bell_concierge" class="xs"></mat-icon>
		} @else {
			{{ diner.initials }}
		}
	</span>
}

